export default function checkNullAmount(value) {
  return /^0*$/.test(value);
}
